import { asyncApi } from "@/services/apiService";

const _baseEndpoint = `${process.env.VUE_APP_BASE_API}/api/shop/reservations`;

export default {
  cancel: async (payload, onBeginCallback, onFinallyCallback) => {
    return asyncApi.put(
      `${_baseEndpoint}/cancel`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  postFeedback: async (payload, onBeginCallback, onFinallyCallback) => {
    return asyncApi.post(
      `${_baseEndpoint}/feedback`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  postNote: async (payload, onBeginCallback, onFinallyCallback) => {
    return asyncApi.post(
      `${_baseEndpoint}/note`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  amendGet: async (
    dinamicEndPoint,
    param,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.get(
      `${_baseEndpoint}/${dinamicEndPoint}?${param}`,
      onBeginCallback,
      onFinallyCallback
    );
  },
  amend: async (
    dinamicEndPoint,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.post(
      `${_baseEndpoint}/${dinamicEndPoint}`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  updateAdminNotes: async (payload, onBeginCallback, onFinallyCallback) => {
    return asyncApi.put(
      `${_baseEndpoint}/admin-note`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  },
  acceptAmendment: async (
    payload,
    dinamicEndPoint,
    onBeginCallback,
    onFinallyCallback,
    onErrorCallback
  ) => {
    return asyncApi.post(
      `${_baseEndpoint}/${dinamicEndPoint}`,
      payload,
      onBeginCallback,
      onFinallyCallback,
      onErrorCallback
    );
  },
  updateStop: async (
    dinamicEndPoint,
    payload,
    onBeginCallback,
    onFinallyCallback
  ) => {
    return asyncApi.put(
      `${_baseEndpoint}/${dinamicEndPoint}`,
      payload,
      onBeginCallback,
      onFinallyCallback
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/shop/reservationService.js